import { render, staticRenderFns } from "./autorizar.vue?vue&type=template&id=7cc8b39d&"
import script from "./autorizar.vue?vue&type=script&lang=js&"
export * from "./autorizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports